import {
  Flex,
  Text,
  Button,
  Divider,
  Center,
  Input,
  Link,
  Spinner,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Image,
  Box,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  getAuth,
  applyActionCode,
  verifyPasswordResetCode,
  confirmPasswordReset,
} from 'firebase/auth';

export default function ActionHandler() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Processing...');
  const [newPassword, setNewPassword] = useState('');
  const [showResetForm, setShowResetForm] = useState(false);

  const mode = searchParams.get('mode');
  const oobCode = searchParams.get('oobCode');
  const continueUrl = searchParams.get('continueUrl');

  useEffect(() => {
    const auth = getAuth();

    if (!oobCode || !mode) {
      setStatus('Invalid or missing code.');
      return;
    }

    switch (mode) {
      case 'verifyEmail':
        applyActionCode(auth, oobCode)
          .then(() => {
            setStatus('Email successfully verified!');
            if (continueUrl) setTimeout(() => window.location.href = continueUrl, 2000);
          })
          .catch(() => setStatus('Verification link is invalid or expired.'));
        break;

      case 'resetPassword':
        verifyPasswordResetCode(auth, oobCode)
          .then(() => {
            setStatus('Please enter your new password.');
            setShowResetForm(true);
          })
          .catch(() => setStatus('Reset link is invalid or expired.'));
        break;

      case 'recoverEmail':
        applyActionCode(auth, oobCode)
          .then(() => setStatus('Email successfully restored.'))
          .catch(() => setStatus('Recovery link is invalid or expired.'));
        break;

      default:
        setStatus('Unknown action.');
    }
  }, [mode, oobCode]);

  const handlePasswordReset = () => {
    const auth = getAuth();
    confirmPasswordReset(auth, oobCode, newPassword)
      .then(() => {
        setStatus('Password has been reset. You can now log in.');
        setShowResetForm(false);
        setTimeout(() => navigate('/login'), 2000);
      })
      .catch(() => setStatus('Failed to reset password. The code may be invalid.'));
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '600px', margin: '0 auto' }}>
      <Text color={"#ffffff"} fontSize={"12px"}>{status}</Text>

      {showResetForm && (
        <Flex color={"#718096"} fontSize={"12px"} flexDirection={"column"} gap={"12px"}>
          <Input
            fontSize={"12px"}
            bg={"white"}
            border={"1px solid black"}
            rounded={"lg"}
            type={"password"}
            placeholder="Nytt lösenord"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={{ padding: '0.5rem', marginRight: '0.5rem' }}
          />
          <Button
            fontSize={"12px"}
            rounded={"lg"}
            bg={"#5138EE"}
            color={"white"}
            marginTop={"10px"}
            p={6}
            transition={"0.1s"}
            _hover={{ fontSize: "13px" }}
            onClick={handlePasswordReset}
          >
            Återställ lösenord
          </Button>
        </Flex>
      )}
    </div>
  );
}
